import React, {FC} from 'react'
import BestDateWrapperAtom from '../../@atoms/to_content/best_date_wrapper/best_date_wrapper.atom'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import ButtonDateTimeslotAtom from '../../@atoms/to_forms/button_date_timeslot/button_date_timeslot_atom'
import DateSelectionActionBtnComponent from '../date_selection_action_btn/date_selection_action_btn.component'
import DateSelectionModalHeaderComponent from '../date_selection_modal_header/date_selection_modal_header.component'
import ModalErrorAtom from '../../@atoms/to_content/modal_error/modal_error.atom'
import SkeletonAtom from '../../@atoms/to_layout/skeleton/skeleton.atom'
import SvgIconAtom from '../../@atoms/to_content/svg_icon/svg_icon.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import useBestDate from '../../@hooks/use_best_date'
import utils from '../../utils'

const SubHeader: FC = function ({children}) {
  return (
    <BoxAtom className="subHeader">
      <SvgIconAtom ap_type="greenLeaf" ap_color="inherit" width="24" />
      {children}
    </BoxAtom>
  )
}

const ModalBodyComponent: React.FC = function () {
  const {
    subtitle,
    description,
    matches,
    ref,
    bestDates,
    handleAllSlots,
    buttonAllSlots,
    setError,
    getBookVisitPayload,
  } = useBestDate()

  return bestDates ? (
    <>
      <SubHeader>
        <BoxAtom>
          <TypographyAtom ahd_type="subheading">{subtitle}</TypographyAtom>
          {matches && (
            <TypographyAtom ahd_type="step">{description}</TypographyAtom>
          )}
        </BoxAtom>
      </SubHeader>
      {!matches && (
        <TypographyAtom ahd_type="step">{description}</TypographyAtom>
      )}
      <BoxAtom className="slots-wrapper">
        <ButtonDateTimeslotAtom
          ref={ref}
          ap_data_arr={utils.formatDateTimeSlots(bestDates)}
        />
        <footer className="date-slot-actions">
          <ButtonAtom ap_type="secondary" fullWidth onClick={handleAllSlots}>
            {buttonAllSlots}
          </ButtonAtom>
          <DateSelectionActionBtnComponent
            setError={setError}
            getBookVisitPayload={getBookVisitPayload}
          />
        </footer>
      </BoxAtom>
    </>
  ) : (
    <SkeletonAtom ap_type="best_date_skeleton" />
  )
}

const BestDateComponent: React.FC = function () {
  const {error, buttonForErrorClose} = useBestDate()

  return (
    <BestDateWrapperAtom>
      <DateSelectionModalHeaderComponent />
      {!error.isError ? (
        <ModalBodyComponent />
      ) : (
        <ModalErrorAtom
          btnLabel={buttonForErrorClose}
          errorMsg={error.errorMsg}
        />
      )}
    </BestDateWrapperAtom>
  )
}

export default BestDateComponent
